import { useCallback, startTransition } from 'react';
import { useNavigate, NavigateOptions } from 'react-router-dom';

/**
 * Custom hook for navigation with startTransition to prevent Suspense errors
 * during route changes
 */
export const useTransitionNavigation = () => {
  const navigate = useNavigate();

  const navigateWithTransition = useCallback((
    to: string | number,
    options?: NavigateOptions
  ) => {
    startTransition(() => {
      if (typeof to === 'number') {
        navigate(to);
      } else {
        navigate(to, options);
      }
    });
  }, [navigate]);

  return {
    navigate: navigateWithTransition,
    navigateReplace: useCallback((to: string, options?: Omit<NavigateOptions, 'replace'>) => {
      navigateWithTransition(to, { ...options, replace: true });
    }, [navigateWithTransition]),
    navigateBack: useCallback(() => {
      navigateWithTransition(-1);
    }, [navigateWithTransition]),
    navigateForward: useCallback(() => {
      navigateWithTransition(1);
    }, [navigateWithTransition]),
  };
};

export default useTransitionNavigation;